import { ToastProvider } from "@strust/ui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { shellMessages } from "../features/shell/messages.ts";

/** The app's toast region (Steel Zero Trust `ToastProvider`) with its localized close label. */
export function Toasts({ children }: { readonly children: ReactNode }) {
  const intl = useIntl();
  return (
    <ToastProvider closeLabel={intl.formatMessage(shellMessages.toastClose)}>{children}</ToastProvider>
  );
}
